import { render, staticRenderFns } from "./core_heading.vue?vue&type=template&id=51583b50&scoped=true"
import script from "./core_heading.vue?vue&type=script&lang=js"
export * from "./core_heading.vue?vue&type=script&lang=js"
import style0 from "./core_heading.vue?vue&type=style&index=0&id=51583b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51583b50",
  null
  
)

export default component.exports